import { Badge } from '../../../shared/ui'
import type { KartenZustand } from './kartenApi'

const TEXT: Record<KartenZustand, { tone: 'success' | 'warn' | 'danger' | 'neutral' | 'info'; label: string }> = {
  aktiv:        { tone: 'success', label: 'Aktiv' },
  bald:         { tone: 'warn',    label: 'Läuft bald ab' },
  abgelaufen:   { tone: 'danger',  label: 'Abgelaufen' },
  gesperrt:     { tone: 'danger',  label: 'Gesperrt' },
  'noch-nicht': { tone: 'info',    label: 'Noch nicht gültig' },
}

export default function KartenStatusBadge({ zustand }: { zustand: KartenZustand }) {
  const t = TEXT[zustand]
  return <Badge tone={t.tone}>{t.label}</Badge>
}
